<template>
  <div>
    <NavigationBar
      titel="Benutzer"
      :tabs="tabs"
      :activeTab="activeTab"
    ></NavigationBar>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";

export default {
  name: "admin-users",
  components: {
    NavigationBar,
  },
  data() {
    return {
      activeTab: `accounts`,
      tabs: [
        { id: 1, name: "Benutzerkonten", route: `accounts` },
        { id: 2, name: "Benutzergruppen", route: `groups` },
        { id: 3, name: "Benutzerlabels", route: `labels`, disabled: true },
      ],
    };
  },
};
</script>
